import React, { useState } from 'react'

const RoundFlightResults = ({ flights }) => {
    const [selectedIndex, setSelectedIndex] = useState(0)

    return (
        <div className='flightResults'>
            {flights.map((item, index) => (
                <div
                    key={index}
                    className={`resultCard ${selectedIndex === index ? 'active' : ''}`}
                    onClick={() => setSelectedIndex(index)}
                    role="button"
                    tabIndex={0}
                >
                    <div className='resultCard__main'>
                        <div className='resultCard__airline'>
                            <span className='resultCard__logo'>
                                <img src={item.logo} alt={item.airline} />
                            </span>
                            <div className='resultCard__airlineName'>{item.airline}</div>
                        </div>
                        <div className='resultCard__time'>
                            <div className='resultCard__timeValue'>{item.depTime}</div>
                            <div className='resultCard__timeCode'>{item.depCode}</div>
                        </div>
                        <div className='resultCard__duration'>
                            <div className='resultCard__durationValue bookingConfirmDuration'>
                                {item.duration}
                            </div>
                            <div className='resultCard__stops'>{item.stops}</div>
                        </div>
                        <div className='resultCard__time'>
                            <div className='resultCard__timeValue'>{item.arrTime}</div>
                            <div className='resultCard__timeCode'>{item.arrCode}</div>
                        </div>
                        <div className='resultCard__price'>
                            <div className='resultCard__priceValue'>{item.price}</div>
                        </div>
                    </div>

                    {item.offer_text && (
                        <div className='resultCard__offer'>
                            <span className='resultCard__offerDot' />
                            {item.offer_text}
                        </div>
                    )}
                </div>
            ))}
        </div>
    )
}

export default RoundFlightResults
